module.exports = "<div [ngClass]=\"{'dropdown': true, 'open': isOpenDropdown}\">\n\n    <a class=\"btn btn-primary dropdown-toggle\"\n        (click)=\"onBtnClick()\"\n       [ngClass]=\"{'disabled': !hasAtLeastOneEnabledItem}\">\n        {{title}}\n        <span class=\"caret\"></span>\n    </a>\n\n    <ul class=\"dropdown-menu\">\n        <li *ngFor=\"let item of items\" (click)=\"processListItemClick(item)\" class=\"unselectable\" [ngClass]=\"{'disabled': item.disabled}\">\n            <a>{{item.name}}</a>\n        </li>\n    </ul>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/shared/dropdown/dropdown.component.html
// module id = 1173
// module chunks = 0